export function extractFileNameFromContentDisposition(
  contentDisposition?: string,
): string {
  let filename = "downloaded_file";

  const match = contentDisposition?.match(/filename="?(.+?)"?$/);

  if (match && match[1]) {
    filename = match[1];
  }
  return filename;
}
